import { PureLightTheme } from "../../../../styles/theme"

export const ShowReplyInputStack = {
    marginLeft: "76px",

    [PureLightTheme.breakpoints.down('md')]: {
        marginLeft: "45px",
    }
}

export const TypAnswerFor = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflowWrap: 'anywhere',
}
